var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 131,
    viewBox: "0 0 140 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.512 95.438H71.675C59.3813 95.438 52.4961 104.044 52.4961 113.203C52.4961 121.655 58.3362 130.968 71.675 130.968H122.512V95.4375V95.438Z",
    fill: "#3E4348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.512 130.935C132.171 130.935 140 122.981 140 113.17C140 103.358 132.171 95.4043 122.512 95.4043C112.853 95.4043 105.023 103.358 105.023 113.17C105.023 122.981 112.853 130.935 122.512 130.935Z",
    fill: "#3E4348"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0153 48.0728H19.1789C6.88516 48.0728 0 56.679 0 65.838C0 74.2905 5.83953 83.6033 19.1789 83.6033H70.0153V48.0723V48.0728Z",
    fill: "#3E4348"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0159 83.6027C79.6745 83.6027 87.5044 75.649 87.5044 65.8375C87.5044 56.026 79.6745 48.0723 70.0159 48.0723C60.3572 48.0723 52.5273 56.026 52.5273 65.8375C52.5273 75.649 60.3572 83.6027 70.0159 83.6027Z",
    fill: "#3E4348"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.512 0.740234H71.675C59.3813 0.740234 52.4961 9.34641 52.4961 18.5055C52.4961 26.9574 58.3362 36.2707 71.675 36.2707H122.512V0.740234Z",
    fill: "#3E4348"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.512 36.2707C132.171 36.2707 140 28.3169 140 18.5055C140 8.694 132.171 0.740234 122.512 0.740234C112.853 0.740234 105.023 8.694 105.023 18.5055C105.023 28.3169 112.853 36.2707 122.512 36.2707Z",
    fill: "#3E4348"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleData);
export default __webpack_public_path__ + "static/media/google-data.87108201b899d06e70b97066fda2d06e.svg";
export { ForwardRef as ReactComponent };